import clsx from "clsx";
import "./ConsentModalContent.scss";

type ContentModalContentProps = {
  overrideClassNames?: string;
  children?: React.ReactNode;
};

export const ContentModalContent = ({
  overrideClassNames,
  children,
}: ContentModalContentProps) => {
  return (
    <div className={clsx("ui-consent-modal-body", overrideClassNames)}>
      {children}
    </div>
  );
};
